import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function RevisionModal({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    item,
    loader,
}) {

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit, setValue } = methods;

    useEffect(() => {

        methods.reset({ cancel_reason: '', due_date: ''})

    }, [isOpen])

    useEffect(() => {
        setValue('cancel_reason', item?.appointment_details?.cancel_reason || '')
        setValue('due_date', item?.appointment_details?.due_date || '');
    }, [item, isOpen])

    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => onConfirm(data, "Revision"))}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Revision</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards min-height-auto'>
                            <h2>Translation ID: {appointmentId}</h2>
                            {/* Reason */}
                            <div className="row-primary">
                                <h2>Reason</h2>
                                <Controller
                                    name="cancel_reason"
                                    control={control}
                                    rules={{
                                        required: "Please write reason"
                                    }}
                                    render={({ field }) =>
                                        <>
                                            <textarea
                                                className="type_inp input-in"
                                                {...field}
                                                placeholder='Write reason for Cancel ...'
                                                required
                                            >
                                            </textarea>

                                            {errors?.cancel_reason?.message && (
                                                <ErrorMessage
                                                    text={errors?.cancel_reason?.message}
                                                />
                                            )}
                                        </>
                                    }

                                />
                            </div>
                            <div className="row-primary">
                                <h2>Revised Due Date</h2>
                                <Controller
                                    name="due_date"
                                    control={control}
                                    rules={{
                                        required: "Please select due date"
                                    }}
                                    render={({ field }) => (
                                        <div style={{ width: "100%" }}>
                                            <div className="input-image">
                                                <input
                                                    type="date"
                                                    {...field}
                                                    value={field.value || ""}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.value);
                                                    }}
                                                />
                                                <img
                                                    src="/images/celender.png"
                                                    alt="clock"
                                                    className="custom-icon"
                                                />
                                            </div>
                                            {errors?.due_date?.message && (
                                                <ErrorMessage text={errors.due_date.message} />
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" loader={loader} className={'tomatoRed'} btnText="Send Revision" />
                        <button className="Cancle_button" type='button' onClick={onClose}>Close</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default RevisionModal;